import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";

const NAV_LINKS = [
  { label: "Intelligence", href: "#intelligence" },
  { label: "Features", href: "#features" },
  { label: "How it works", href: "#how" },
  { label: "Showcase", href: "#showcase" },
  { label: "Pricing", href: "#pricing" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B0B0B]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <div className="relative w-8 h-8 rounded-lg bg-gradient-to-br from-[#F3CE5A] to-[#8B6914] flex items-center justify-center shadow-[0_0_24px_rgba(212,175,55,0.35)]">
            <span className="font-display text-black text-base font-bold">F</span>
          </div>
          <span className="font-display text-lg md:text-xl tracking-tight text-white">Facetra</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Link
              to="/app"
              data-testid="nav-studio-link"
              className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/45 bg-[#D4AF37]/10 text-[#D4AF37] text-sm px-4 py-2 hover:bg-[#D4AF37]/15 transition"
            >
              Open Studio →
            </Link>
          ) : (
            <Link
              to="/signin"
              data-testid="nav-signin-link"
              className="text-xs sm:text-sm text-white/75 hover:text-white px-2 sm:px-3 py-2 transition"
            >
              Sign in
            </Link>
          )}
          <Link
            to={typeof window !== "undefined" ? `/signup${window.location.search || ""}` : "/signup"}
            data-testid="nav-cta-signup"
            className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37] text-black text-sm font-medium px-5 py-2.5 hover:bg-[#F3CE5A] transition-all duration-300 shadow-[0_4px_30px_-8px_rgba(212,175,55,0.55)]"
          >
            Create account
            <span className="inline-block translate-y-[1px]">→</span>
          </Link>
        </div>
      </div>
    </motion.header>
  );
}
